export enum JABBER_CONNECTION_STATUS {
  CONNECTING = 1,
  CONNECTED = 2,
  DISCONNECTED = 3,
  DISCONNECTING = 4,
  RECONNECTING = 5
}
